import { render } from "./BagQtde02.vue?vue&type=template&id=74aed8c2&scoped=true"
import script from "./BagQtde02.vue?vue&type=script&lang=js"
export * from "./BagQtde02.vue?vue&type=script&lang=js"

import "./BagQtde02.vue?vue&type=style&index=0&id=74aed8c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74aed8c2"]])

export default __exports__